import { call, put, select } from 'redux-saga/effects';
import { backendClient } from '../../../services/api/backend-client';
import { fetchCrmStatusAction } from '../fetchCrmStatus/action';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectCrmCatalog } from '../../../state/integration/integrationSlice';
import { isApiKeyCrm } from '../../../utils/crmUtils';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { openExternal } from '../../../utils/openExternal';

export function* connectCrmSaga(action) {
    const { crm, subdomain, apiKey } = action.payload;
    const catalog = yield select(selectCrmCatalog);

    if (isApiKeyCrm(crm, catalog[crm])) {
        try {
            yield call(
                [backendClient, backendClient.post],
                `integrations/${crm}/connect`,
                { apiKey, ...(subdomain ? { subdomain } : {}) }
            );
            yield put(fetchCrmStatusAction({ crm }));
            yield put(showSnackbar({ message: `${crm} connected.`, severity: 'success' }));
        } catch (err) {
            bugsnagClient.notify(err);
            console.error(`Failed to connect ${crm} via API key`, err?.response?.status, err?.message);
            yield put(showSnackbar({
                message: err?.response?.data?.error || `Failed to connect ${crm}.`,
                severity: 'error',
            }));
        }
        return;
    }

    try {
        const params = subdomain ? { params: { subdomain } } : {};
        const { data } = yield call(
            [backendClient, backendClient.get],
            `integrations/${crm}/connect`,
            params
        );
        openExternal(data.url);
    } catch (err) {
        bugsnagClient.notify(err);
        console.error(`Failed to get ${crm} auth URL`, err?.response?.status, err?.message);
    }
}
